document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.facilities').forEach(section => {
        const list = section.querySelector('.facilities__list');
        const items = section.querySelectorAll('.facilities__item');
        const media = section.querySelector('.facilities__media');
        const mediaTitle = media.querySelector('.facilities__media-title');
        const mediaList = media.querySelector('.facilities__media-list');
        const mediaImage = media.querySelector('.facilities__image');

        let lastVisible = null;

        const updateMedia = item => {
            media.classList.add('facilities__media--hidden');
            items.forEach(i => i.classList.add('facilities__item--disabled'));
            items.forEach(i => i.classList.remove('facilities__item--active'));
            item.classList.add('facilities__item--active');

            setTimeout(() => {
                const subItems = item.dataset.items ? JSON.parse(item.dataset.items) : [];
                const newImg = new Image();
                newImg.src = item.dataset.imageUrl;
                newImg.alt = item.dataset.imageAlt;
                newImg.onload = () => {
                    mediaTitle.textContent = item.querySelector('.facilities__item-title').textContent;
                    mediaImage.src = newImg.src;
                    mediaImage.alt = newImg.alt;
                    mediaList.innerHTML = subItems.map(sub => `<li class="facilities__media-item">${sub.title}</li>`).join('');
                    media.classList.remove('facilities__media--hidden');
                    items.forEach(i => i.classList.remove('facilities__item--disabled'));
                };
            }, 300);
        };

        const getVisibleItem = () => {
            const listRect = list.getBoundingClientRect();
            let closest = items[0];
            let minDiff = Infinity;
            items.forEach(item => {
                const rect = item.getBoundingClientRect();
                const diff = Math.abs(rect.left - listRect.left);
                if (diff < minDiff) {
                    minDiff = diff;
                    closest = item;
                }
            });
            return closest;
        };

        const preloadImage = url => {
            return new Promise(resolve => {
                const img = new Image();
                img.src = url;
                img.onload = resolve;
                img.onerror = resolve;
            });
        }

        items.forEach(item => item.addEventListener('click', () => {
            if (item.classList.contains('facilities__item--disabled')) return;
            lastVisible = item;
            updateMedia(item);
        }));

        (async () => {
            await Promise.all(Array.from(items).map(item => preloadImage(item.dataset.imageUrl)));
        })();

        if (window.innerWidth <= 1024) {
            let index = 0;
            let auto = true;
            let scrollTimer = null;
            let direction = 1;

            const syncFromScroll = () => {
                const current = getVisibleItem();
                if (current === lastVisible) return;
                lastVisible = current;
                index = [...items].indexOf(current);
                updateMedia(current);
            };

            list.addEventListener('scroll', () => {
                auto = false;
                clearTimeout(scrollTimer);
                clearTimeout(list._autoTimer);

                scrollTimer = setTimeout(() => {
                    syncFromScroll();
                    list._autoTimer = setTimeout(() => auto = true, 4000);
                }, 150);
            });

            setInterval(() => {
                if (!auto) return;

                index += direction;

                if (index === items.length - 1 || index === 0) {
                    direction *= -1;
                }

                const item = items[index];
                lastVisible = item;
                updateMedia(item);
                item.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
            }, 4000);
        }

        if (items[0]) {
            lastVisible = items[0];
            updateMedia(items[0]);
        }
    });
});